import {Component} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-edit-action',
   templateUrl: './edit-action.component.html',
   styleUrls: ['./edit-action.component.css']
})
export class EditActionComponent {
   public actions = [
      {value: 'NS', viewValue: 'Need to Sign'},
      {value: 'CC', viewValue: 'CC'}
   ];

   constructor(private dialogRef: MatDialogRef<EditActionComponent>) {
   }

   public actionSelected: string;

   updateAction() {
      this.dialogRef.close(this.actionSelected);
   }
}
